import * as React from "react";
const SvgAnimationMarker = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 21 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.9641 16C12.4245 18.6667 8.5755 18.6667 7.0359 16L1.40673 6.25C-0.132868 3.58333 1.79164 0.25 4.87084 0.25L16.1292 0.250001C19.2084 0.250001 21.1329 3.58334 19.5933 6.25L13.9641 16Z", fill: "currentColor" }));
export default SvgAnimationMarker;
